import { ocapiClient } from '../../../api-clients/ocapi/client';
import { createOrGetFetchedState } from '../../../utils/fetched-data/create-or-get-fetched-state';
import { getCacheDuration } from '../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../utils/load-data-from-api';
import { logger } from '../../../utils/logger';
import { nonEmptyStringValidator } from '../../../utils/validators/string';
import { seatingDomainStore } from '../store';
/**
 * Loads and stores the seat availability data for a given showtime.
 * Will load the order-specific data if an orderId is provided.
 */
export const loadSeatAvailabilityForShowtime = async (showtimeId, orderId) => {
    if (!nonEmptyStringValidator(showtimeId, logger.error, 'showtimeId')) {
        throw new Error('Cannot load seat availability. Provided showtimeId is invalid.');
    }
    const state = createOrGetFetchedState(seatingDomainStore.data.seatAvailabilities, showtimeId);
    const api = orderId
        ? () => ocapiClient.instance.v1.seating.availability.getForOrder(orderId, showtimeId)
        : () => ocapiClient.instance.v1.seating.availability.getForShowtime(showtimeId);
    return await loadDataFromApi({
        api,
        state,
        cacheDuration: getCacheDuration('seatAvailabilities')
    });
};
